import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'
import type { IProjectNote } from '../../../Model/Project/IProjectNote.js'

export const GetNotesEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.getNotesRequest.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return ProjectRepository.getNotes(action.payload.projectId).pipe(
        mergeMap((response: IProjectNote[]) =>
          of(
            project.getNotesRequestSuccess({
              projectId: action.payload.projectId,
              notes: response
            })
          )
        ),
        catchError((error) => of(project.getNotesRequestFailure({ error })))
      )
    })
  )
